<template>
  <div
    :class="[
      $style.item,
      $style['size_' + size],
      $style['highlight_' + highlight],
      {
        [$style.active]: active,
        [$style.disabled]: disabled,
        [$style.has_left]: hasLeft,
      },
    ]"
  >
    <slot name="left" />
    <div :class="$style.content">
      <slot />
    </div>
    <div
      v-if="hasRight"
      :class="$style.right"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VgpDropListItem',

  props: {
    size: {
      type: String,
      default: 'sm',
      validator: v => ['xs', 'sm', 'lg'].includes(v),
    },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    highlight: {
      type: String,
      default: 'fill',
      validator: v => ['fill', 'chip', 'subtle'].includes(v),
    },
  },

  computed: {
    hasLeft() {
      return !!this.$slots.left;
    },

    hasRight() {
      return !!this.$slots.right;
    },
  },
};
</script>

<style module lang="less" src="./dropListItem.less"></style>
